import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import {
  recentChangesRequested,
  recentChangesReceived,
  recentChangesFailed,
} from './recentChangesSlice';

export const fetchRecentChanges = (sheetId) => async (dispatch) => {
  if (!sheetId) return;
  dispatch(recentChangesRequested({ sheetId }));
  try {
    const res = await $api.get(
      `${process.env.REACT_APP_BASE_URL}/sheets/${sheetId}/recent-changes`,
      getOptions()
    );
    dispatch(recentChangesReceived({ sheetId, items: res.data || [] }));
  } catch (e) {
    console.error(e);
    dispatch(recentChangesFailed());
  }
};
